export function downloadFile(file: any, filename: string) {
  const url = window.URL.createObjectURL(new Blob([file]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/utils/downloadUtil.ts